import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { TailwindButtonDirective } from '../../../components/button/tailwind-button.directive';
import { AuthService } from '../../../services/auth.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { TextInputComponent } from '../../../components/input/text-input/text-input.component';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [ReactiveFormsModule, TailwindButtonDirective, DialogComponent, TextInputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private destroyRef = inject(DestroyRef);

  showWaitDialog = false;
  showErrorDialog = false;

  disableButton = false;

  error = '';

  loginForm = new FormGroup({
    mailAddress: new FormControl('', [Validators.required]),
  });

  constructor(
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.authService
      .getLogggedInUser()
      .pipe(
        filter((user) => !!user),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.router.navigateByUrl('/'));
  }

  async login() {
    this.loginForm.markAllAsTouched();
    if (!this.loginForm.valid) {
      return;
    }
    this.disableButton = true;
    const email = this.loginForm.value.mailAddress;

    try {
      await this.authService.signInEmail(email!, true);
      this.showWaitDialog = true;
    } catch (e) {
      this.showWaitDialog = false;

      // @ts-ignore
      this.error = e.message;
      this.showErrorDialog = true;
      console.error(e);
    }
    this.cdr.markForCheck();
  }

  closeModal() {
    this.showWaitDialog = false;
    this.showErrorDialog = false;
    this.disableButton = false;
    this.cdr.markForCheck();
  }
}
